module.exports = __webpack_public_path__ + "static/media/39-3.ded3362b.mp3";